import request from './../utils/request'

const baseURL = process.env.REACT_APP_API_COMMENT
/**
 * @author 小周先生
 * @date 2021-06-11
 * @param {any} articleId
 * @returns {any}
 * @description 获取文稿详情
 */
export const getArticle = articleId =>
  request({
    method: 'get',
    url: baseURL + '/mobile/cms/articlewithrelated?version=v3',
    params: {
      articleId
    }
  })

/**
 *
 * @author 小周先生
 * @param {any} articleId
 * @returns {any}
 * @description 获取预览文稿详情
 */
export const getArticlePreview = articleId =>
  request({
    method: 'get',
    url: baseURL + '/mobile/cms/articlepreview',
    params: {
      articleId
    }
  })
/**
 * 获取观看人数
 * @author 铁少波
 * @date 2022-06-27
 * @param articleId 文章Id
 * @returns {any}
 */
export const getClickNum = articleId => {
  return request({
    method: 'get',
    url: baseURL + `/mobile/cms/clickNum?articleId=${articleId}`
  })
}
/**
 * 获取直播评论
 * @param {*} url
 * @param {*} articleId
 * @returns
 */
export const getLiveCommentList = articleId =>
  request({
    method: 'get',
    url: baseURL + `/dx-bridge/get-all-by-objectId/${articleId}`
  })

/**
 * 获取栏目信息
 * @author 铁少波
 * @date 2022-06-27
 * @param {any} channelId 栏目id
 * @returns {any}
 */
export const getColumnInfo = channelId => {
  return request({
    method: 'get',
    url: baseURL + `/mobile/cms/channel?channelId=${channelId}&tenantId=1`
  })
}

export const getNumByChannelId = channelId => {
  return request({
    method: 'get',
    url: baseURL + `/mobile/cms/getNumByChannelId?channelId=${channelId}`
  })
}

/**
 * 获取栏目下的文章列表
 * @param {any} channelId 栏目id
 * @returns {any}
 */
export const getChannelDocs = params => {
  return request({
    method: 'get',
    url: baseURL + '/mobile/cms/articles',
    params
  })
}

/**
 *
 * @param {object} param
 * @description 查询指定栏目下的子栏目
 * @returns
 */
export const getChannelList = param => {
  return request({
    method: 'get',
    url: `${baseURL}/mobile/cms/channelsbyparentchanneid`,
    params: {
      ...param
    }
  })
}

/**
 * 获取直播消息列表
 * @author xiawang1024
 * @date 2021-06-11
 * @param {any} articleId
 * @returns {any}
 */

export const getLiveMsgs = (url, articleId) =>
  request({
    method: 'get',
    url,
    params: {
      articleId,
      pageNo: 1,
      pageSize: 50
    }
  })

export const getLiveMsg = articleId =>
  request({
    method: 'get',
    url: baseURL + '/mobile/cms/searchlivecomment',
    params: {
      articleId,
      pageNo: 1,
      pageSize: 50
    }
  })
/**
 * 获取城市天气预报
 * @author xiawang1024
 * @date 2021-06-30
 * @param {any} cityName
 * @returns {any}
 */
export const getCityWeather = (url, cityName) => {
  if (cityName) {
    return request({
      method: 'get',
      url,
      params: {
        cityName
      }
    })
  }
}

/**
 * 获取直播流地址
 * @author xiawang1024
 * @date 2021-12-13
 * @param {any} liveId
 * @param {any} tenantId
 * @returns {any}
 */
export const getLiveStream = (liveId, tenantId) =>
  request({
    method: 'get',
    url: baseURL + '/mobile/stream/selectOneByLiveIdAndTenantId',
    params: {
      liveId,
      tenantId
    }
  })

/**
 * 获取直播流地址2（自定义loader，用于短期密钥续接）
 * @author xiawang1024
 * @date 2022-03-02
 * @param {any} liveId
 * @param {any} tenantId
 * @returns {any}
 */
export const getLiveStream2 = async (liveId, tenantId) =>
  request({
    method: 'get',
    url: baseURL + '/mobile/stream/selectOneEffectiveDurationByLiveIdAndTenantId',
    params: {
      liveId,
      tenantId
    }
  })

/**
 * 获取大象号信息（带矩阵信息）
 * @author xiawang1024
 * @date 2022-03-22
 * @param {any} fusionId
 * @param {any} tenantId
 * @returns {any}
 */
export const getDxhInfo = fusionId =>
  request({
    method: 'POST',
    url: baseURL + '/mobile/cms/fusionplate',
    data: {
      fusionId,
      tenantId: 1
    }
  })
